import { useCallback } from 'react'

import { useAuthenticatedFirebaseUser } from '@/auth/useFirebaseUser'

export const useBackToPilote = (option?: { signOut: boolean }) => {
  const { signOut } = useAuthenticatedFirebaseUser()
  return useCallback(async () => {
    if (option?.signOut) {
      await signOut()
    }
    globalThis.location.href = `${import.meta.env.VITE_PILOTE_BASE_URL}/app/transport`
  }, [signOut])
}
